import React from 'react';

const DOM_CSS = () => {
  return (
    <div >
      <h1>DOM_CSS</h1>
      <p>Placeholder component for: "DOM CSS"</p>
    </div>
  );
};

export default DOM_CSS;
